export default __webpack_public_path__ + "static/media/connect-artwork.50a74d91.svg";